// extracted by mini-css-extract-plugin
export default {"home-content":"homecontent_home-content__8aEqq","home-content__title":"homecontent_home-content__title__N0vK9"};